// extracted by mini-css-extract-plugin
module.exports = {"status_screen":"Fv","error":"Fx","success":"Fz"};